export const authURL = "/auth";
export const airtableURL = "/airtable";
export const stripeURL = "/stripe";
export const uploadURL = "/upload";
export const emailURL = "/email";
